//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { theme as unisonTheme } from '@bvengineering/unison-core';

export const STREAM_MEDIA_SIZE_PX = 300;

export const PARTNER_STREAM_TOP_BAR_MAX_WIDTH = `calc(${unisonTheme.wideMeasure} * 2 + ${unisonTheme.spacings[2]})`;

export const AUTO_DISTRIBUTION_HELPER_TEXT =
  'At 12:00 AM GMT, all pending content will be distributed to the galleries selected in the auto-distribution settings.';
